<template>
    <router-link :to="{name: 'home'}">
        <div v-if="showPartnerLogo" class="flex flex-col items-center">
            <img
                :alt="`${(brand_profile.name || 'Valur')} logo`"
                :class="logoWidthClass"
                :height="(brand_profile.style || {})['header_logo_style'] === undefined ? 15: ''"
                :src="logoVariant"
                :style="(brand_profile.style || {})['header_logo_style']"
            >
        </div>
        <img
            v-else
            alt="Valur logo"
            :class="logoWidthClass"
            :src="valurLogoVariant"
        >
    </router-link>
</template>

<script>
    import advisory_partner_mixin from '@/mixins/advisory_partner_mixin';
    import logoIconImg from '@/assets/img/logo_icon.png';
    import logoImg from '@/assets/img/logo.png';

    export default {
        name: 'v-logo',
        mixins: [advisory_partner_mixin],
        props: {
            // Render the Valur logo even when a white-label partner is active
            forceDefault: {
                type: Boolean,
                default: false,
            },
            icon: {
                type: Boolean,
                default: false,
            },
            widthClass: {
                type: String,
                default: '',
            },
        },
        computed: {
            hasLogoIcon() {
                return this.brand_profile.logo_icon_url !== null;
            },
            logoWidthClass() {
                if (this.widthClass) return this.widthClass;
                return this.icon && this.hasLogoIcon ? 'w-24' : this.icon ? 'w-28 py-6' : 'w-28';
            },
            logoVariant() {
                const logoIconUrl = this.brand_profile.logo_icon_url;
                const logoUrl = this.brand_profile.logo_url;
                return this.icon && this.hasLogoIcon ? logoIconUrl : logoUrl;
            },
            // A partner that hasn't uploaded a logo yet (newly created workspaces, and
            // any firm ops set up before the file was ready) would otherwise render a
            // broken <img> with its name as alt text. Fall back to the Valur mark —
            // same call VSidebarLinks already makes for the workspace header.
            showPartnerLogo() {
                return this.isPartner && !this.forceDefault && Boolean(this.logoVariant);
            },
            valurLogoVariant() {
                return this.icon ? logoIconImg : logoImg;
            },
        },
    };
</script>
